import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenRecorderComponent } from './screen-recorder.component';
import { VideoRecordingService } from './screen-recorder.service';
import { SharedModule } from '../shared-module/shared-module.module';
import { FormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';






@NgModule({
  declarations: [ScreenRecorderComponent],
  imports: [
    // CommonModule, e nao BrowserModule: modulo de funcionalidade nunca importa
    // o BrowserModule. Ele lanca NG05100 na segunda construcao, e um componente
    // standalone que importe este modulo instanciaria os providers dele num
    // injetor proprio.
    CommonModule,
    FormsModule,
    NzRadioModule,
    NzButtonModule,
    NzIconModule,
    NzDividerModule,
    NzProgressModule,
    NzToolTipModule,
    SharedModule
  ],
  providers:[VideoRecordingService],
  exports:[
    ScreenRecorderComponent
  ]
})
export class ScreenRecorderModule { }
